import React from "react";
import { Col, Form } from "react-bootstrap";
import moment from "moment";
import "moment/locale/sv";

export interface DateFieldProps {
  label: string;
  value: string | null | undefined;
  colSize?: number;
  isEditable?: boolean;
  isAddMode?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DateField: React.FC<DateFieldProps> = ({
  label,
  value,
  colSize = 4,
  isEditable = false,
  isAddMode = false,
  onChange,
}) => (
  <Col xs={12} md={colSize}>
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type={isEditable ? "date" : "text"}
        value={isAddMode ? (value ?? "") : moment(value).format("yyyy-MM-DD")}
        readOnly={!isEditable}
        disabled={!isEditable}
        onChange={isEditable ? onChange : undefined}
      />
    </Form.Group>
  </Col>
);

export default DateField;
